import { Alert, Box, Flex, Text } from '@chakra-ui/react'
import type { ReactNode } from 'react'

export type StatusStateLayout = 'centered' | 'alert'

export type StatusStateAlertStatus = 'error' | 'info'

interface CenteredStateProps {
  icon?: ReactNode
  title?: string
  description?: string
  action?: ReactNode
  titleColor?: string
  role?: string
}

export const CenteredState = ({
  icon,
  title,
  description,
  action,
  titleColor = 'fg.muted',
  role,
}: CenteredStateProps) => (
  <Flex direction="column" align="center" py="2.5rem" gap="1rem" role={role}>
    {icon ? (
      <Box
        color="border.default"
        css={{ '& svg': { width: '3.5rem', height: '3.5rem' } }}
      >
        {icon}
      </Box>
    ) : null}
    {title || description ? (
      <Flex
        direction="column"
        py="0.5rem"
        px="1.5rem"
        gap="0.5rem"
        align="center"
      >
        {title ? (
          <Text fontWeight="bold" textAlign="center" color={titleColor}>
            {title}
          </Text>
        ) : null}
        {description ? (
          <Text fontSize="sm" textAlign="center" color="fg.muted">
            {description}
          </Text>
        ) : null}
      </Flex>
    ) : null}
    {action}
  </Flex>
)

interface AlertStateProps {
  status: StatusStateAlertStatus
  icon?: ReactNode
  title?: string
  description?: string
  action?: ReactNode
}

export const AlertState = ({
  status,
  icon,
  title,
  description,
  action,
}: AlertStateProps) => (
  <Alert.Root status={status} p={4}>
    {icon ?? <Alert.Indicator />}
    <Box>
      {title ? <Text fontWeight="bold">{title}</Text> : null}
      {description ? <Text>{description}</Text> : null}
      {action}
    </Box>
  </Alert.Root>
)
